<template id="personal_center">
	<div>
		<div class="col-md-2 mt-3 centre_sm_none">
			<div class="personalManagement pt-3">
				<div class="mb-3">
					<p v-if="user.thumb">
						<img :src="user.thumb" class="account_portrait" />
					</p>
                    <p v-if="!user.thumb">
                        <img src="../../../assets/images/silkRoadBase/nohead.png?3907bf5ad0b32901cfd7def1ad511948" class="account_portrait" />
                    </p>
					<p class="mb-2 mt-2">{{user.nickname}}</p>

					<img v-if="user.level > 1" src="../../../assets/images/silkRoadBase/svip.png" />
                    <p class="mb-2 mt-2" v-if="user.level > 1" style="height:16px;font-size:11px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(133,144,166,1);line-height:16px;">Date of expiry {{user.expire}}</p>
                    <img v-if="user.level == 1" src="../../../assets/images/silkRoadBase/vip.png" />
                    <p class="mb-2 mt-2" v-if="user.level == 1" style="height:16px;font-size:11px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(133,144,166,1);line-height:16px;">No membership has been opened yet.</p>
				</div>
				<div class="personalSetting">
					<ul class="p-0">
						<li>
							<router-link to="/accountSettings/accounts" class="nav-link">
								Account settings
							</router-link>
						</li>
						<li>
							<router-link to="/accountSettings/collection" class="nav-link">
								Collection management
							</router-link>
						</li>
                        <li>
                            <router-link to="/accountSettings/allDeal" class="nav-link">
								All orders
                            </router-link>
                        </li>
						<li>
							<router-link to="/accountSettings/menberCenter" class="nav-link">
								Member center
							</router-link>
						</li>
						<li>
							<router-link to="/accountSettings/myAttention" class="nav-link">
								My focus
							</router-link>
						</li>
						<li>
							<router-link to="/accountSettings/myComment" class="nav-link">
								My comments
							</router-link>
						</li>
						<!--<li>-->
							<!--<router-link to="/accountSettings/my_report" class="nav-link">-->
								<!--我的报告-->
							<!--</router-link>-->
						<!--</li>-->
						<li>
							<router-link to="/accountSettings/contribute" class="nav-link">
								Contribute
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>

        <keep-alive>
            <router-view class="col-md-10 pl-0 mt-3 centre_sm_none" v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view class="col-md-10 pl-0 mt-3 centre_sm_none" v-if="!$route.meta.keepAlive"></router-view>

	</div>
</template>
<script>
	export default({
		name: 'accountSettings',
		data: function() {
			return {
				user: {}
			}
		},
		created: function() {
			let self = this;
			// 获取用户信息
            this.$axios.post('/api/pc/getmember').then(data => {
                if (data.data.state) {
                    self.user=data.data.data;
                }
            })

		}
	})
</script>
